import React, { FC } from "react";
import { Card } from "../../types/card";
import styles from "./card.module.scss";
import Image from "next/image";
import customImageLoader from "../../lib/imageLoader";

type CardProps = {
	card: Card;
};

const Card: FC<CardProps> = ({ card }) => (
	<div className={styles.card}>
		<h2>{card.name}</h2>
		<div>
			<div>
				<Image
					src={card.image}
					loader={customImageLoader}
					layout="responsive"
					width={100}
					height={100}
					alt={`Obrázek karty: ${card.name}`}
					placeholder="blur"
					loading="lazy"
				/>
			</div>
			<p>{card.description}</p>
		</div>
	</div>
);

export default Card;
